import React from 'react';
import { useFormikContext } from 'formik';

import { FieldGroup } from "../../components"

const FieldFilter = ({
  filter,
  name,
  placeholder,
  readOnly,
  prependStaticOptions,
  isMulti,
}) => {
  const { values: { category_id, brand_id } } = useFormikContext();

  return (
    <FieldGroup
      {...{
        placeholder,
        name,
        disabled: readOnly,
        type: 'select',
        optionsUrl: `/api/product/filter-values/${category_id}/${brand_id}/${filter}`,
        prependStaticOptions,
        isMulti,
      }}
    />
  );
}

export default FieldFilter;
